/**
 * ScrollToTop Component
 * 
 * Utility component that automatically scrolls to the top of the page
 * whenever the route changes. This provides a better user experience
 * when navigating between pages, ensuring users start at the top of
 * new content rather than at the previous scroll position.
 * 
 * Uses a custom hook (useScrollToTop) to handle the scroll behavior
 * when the location changes. Returns null as it doesn't render any UI.
 * 
 * Typically placed in the main App component or Router configuration.
 * 
 * @component
 */

import { useScrollToTop } from '../hooks/useScrollToTop';

export const ScrollToTop = () => {
  // Custom hook handles scrolling to top on route changes
  useScrollToTop();
  
  // Component doesn't render any UI, just handles side effect
  return null;
};
